<template>
  <multiselect
    ref="multiselect"
    :value="value"
    :options="options"
    :track-by="trackBy"
    :label="label"
    :openDirection="$mq !== 'smobil' ? 'bottom' : ''"
    :name="name"
    :placeholder="placeholder "
    :show-labels="$mq !== 'smobil'"
    @open="handleOpen"
    @close="handleClose"
    @input="handleInput"
    @select="handleSelect"
  >
    <div slot="noResult">No elements found</div>
    <template slot="clear" slot-scope="props">
      <div
        v-if="$mq === 'smobil'"
        class="multiselect__close"
        @mousedown.prevent.stop="handleClickClose"
      >
        ╳
      </div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "PliSelectChatBot",

  components: {
    Multiselect,
  },
  data() {
    return {
      isOpen: false,
      selectPlaceholder: ''
    }
  },
  props: ["value", "options", "trackBy", "label", "name", "placeholder"],
  mounted() {
    // TODO: Remove the below lines if the search auto focus is okay. 
    // Currently it popups 
    // setTimeout(() => {
    //     this.$refs.multiselect.$el.focus()
    //   }, 2000);

  },
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },

    handleSelect(value) {
      this.$emit("select", value);
    },

    handleOpen() {
      if (this.$mq !== "smobil") {
        return;
      }
      this.$nextTick(() => {
        document.querySelector(".wizard-header").style.display = "none";
        document.body.classList.add("multiselect_noscroll");
        document.documentElement.classList.add("multiselect_noscroll");
      });
    },

  
    handleClose() {
      if (this.$mq !== "smobil") {
        return;
      }
      this.$nextTick(() => {
        document.querySelector(".wizard-header").style.display = "block";
        document.body.classList.remove("multiselect_noscroll");
        document.documentElement.classList.remove("multiselect_noscroll");
      });
    },

    handleClickClose() {
      this.$refs.multiselect.toggle();
    },

    focus () {
      this.$refs.multiselect.$el.focus()
    }
    
    
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect_noscroll {
  overflow: hidden;
}

.multiselect__input,
.multiselect__single {
  background-color: #fff;
}

.multiselect__select {
  height: 43px;
  &:before{
    color: #1e98e0 im !important;
    border-color: #1e98e0 #1e98e000 transparent !important;
  }
}

@media screen and (max-width: 480px) {
  .multiselect--active {
    .multiselect__input {
      display: block;
    }
  }
  .multiselect__input {
    display: none;
  }

  .chat-responses {
    .multiselect__content-wrapper {
      top: -62vh !important;
    }
    .multiselect__input {
      top: -70vh !important;
      width: 85vw !important;
      height: 60px;
      position: absolute;
      left: 0px;
      z-index: 10000;
    }
  }
}

.multiselect__tags {
  background-color: #fff;
  padding: 12px 40px 6px 8px;

  @media screen and (max-width: 480px) {
    .multiselect--active & {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      border-radius: 0;
    }

  }
}
.multiselect__content-wrapper {
  max-height: 200px !important;
  max-width: 100%;
  overflow-x: hidden !important;

  @media screen and (max-width: 480px) {
    position: fixed;
    top: -80vh !important;
    right: 0;
    bottom: 0 !important;
    left: 0;
    margin: 0;
    z-index: 1000;
    max-height: none !important;
    border-radius: 0 !important;
  }
}

.multiselect__content {
  max-width: 500px !important;
  margin-left: 0 !important;

  @media screen and (max-width: 480px) {
    max-width: 100% !important;
    z-index: 1000;
    background-color: #fff;
  }
}

.multiselect__close {
  display: none;

  @media screen and (max-width: 480px) {
    .multiselect--active & {
      display: block;
      position: fixed;
      top: 0;
      right: 0;
      padding: 12px;
      z-index: 100;
    }
  }
}
</style>
